import { IAppState } from '../common/state';

export const getNewbuildingSimilarAdPath = ({ newbuildingSimilarOffersBlock: block }: IAppState): string | null => {
  return block && block.offers.length ? block.offerListingUrl : null;
};
